import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/sections/Hero";
import ChiSiamo from "@/sections/ChiSiamo";
import Servizi from "@/sections/Servizi";
import PortfolioSection from "@/sections/PortfolioSection";
import Recensioni from "@/sections/Recensioni";
import Contatti from "@/sections/Contatti";
import SEO from "@/components/SEO";

const HOME_JSONLD = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://dogaparquet.com/#webpage",
    url: "https://dogaparquet.com/",
    name: "Dogaparquet — L’arte del legno, la qualità che dura",
    isPartOf: { "@id": "https://dogaparquet.com/#website" },
    about: { "@id": "https://dogaparquet.com/#business" },
    inLanguage: "it-IT",
};

export default function Home() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    80,
                );
            }
        }
    }, [hash]);

    return (
        <main data-testid="home-page">
            <SEO
                title={null}
                description="Dogaparquet di Gianluca Occhipinti — Artigiano del legno a Modica (RG). Posa parquet, decking esterni, SPC, restauro e consulenza in tutta la Sicilia sud-orientale. Oltre 20 anni di esperienza, 350+ progetti realizzati."
                path="/"
                keywords="parquet Modica, posa parquet Ragusa, decking Sicilia, parchettista Modica, SPC, laminato, restauro parquet"
                jsonLd={HOME_JSONLD}
            />
            <Hero />
            <ChiSiamo />
            <Servizi />
            <PortfolioSection />
            <Recensioni />
            <Contatti />
        </main>
    );
}
